import {
  MobileOpenClassSessionDetails,
  MobileOpenClassSessionParticipant,
  MobileOpenClassSessionSummary,
  OpenClassSessionParticipantUpdate,
} from '../types/OpenClassSession';

import client from './client';

export type OpenClassSessionFilter = {
  from: string;
  to: string;
  instructorId?: number;
};

export const getOpenClassSessions = (filter: OpenClassSessionFilter) =>
  client.get<MobileOpenClassSessionSummary[]>('/open-class-sessions/mobile', {
    params: filter,
  });

export const getOpenClassSession = (sessionId: number) =>
  client.get<MobileOpenClassSessionDetails>(
    `/open-class-sessions/mobile/${sessionId}`,
  );

export const getOpenClassSessionParticipants = (sessionId: number) =>
  client.get<MobileOpenClassSessionParticipant[]>(
    `/open-class-sessions/mobile/${sessionId}/participants`,
  );

export const updateOpenClassSessionParticipants = (
  sessionId: number,
  participants: OpenClassSessionParticipantUpdate[],
) =>
  client.put<MobileOpenClassSessionParticipant[]>(
    `/open-class-sessions/mobile/${sessionId}/participants`,
    { participants },
  );
